window.addEventListener('load', () => {
  const heroBanner = document.querySelector('.shopify-section.hero-banner');
  if (heroBanner !== null) {
    const buttons = heroBanner.querySelectorAll('.hero-cta');
    const nav = document.getElementById('sticky-nav');
    if (buttons !== null) {
      for (const button of buttons) {
        const embedContainer = document.getElementById(button.dataset.id);
        button.addEventListener('click', () => {
          if (embedContainer !== null) {
            embedContainer.scrollIntoView({
              block: 'center',
              behavior: 'smooth'
            });
            const scrolledY = window.scrollY;
            if (scrolledY) {
              window.scroll(0, scrolledY - nav.getBoundingClientRect().height);
            }
            manageFocus(embedContainer);
          }
        });
      }
    }
  }
  function scrollIntoViewOffset(destination, offset) {
    window.scrollTo({
      behavior: 'smooth',
      top: destination.getBoundingClientRect().top - document.body.getBoundingClientRect().top - offset
    });
  }
  const links = document.querySelectorAll('[href^="#"]');
  if (links.length > 0) {
    for (const link of links) {
      if (link.href !== undefined) {
        const newUrl = new URL(link.href);
        const urlHash = newUrl.hash;
        if (urlHash) {
          link.addEventListener('click', event => {
            event.preventDefault();
            const link = urlHash.replace('#', '');
            const clickDestination = document.getElementById(link);
            if (clickDestination === null) {
              return;
            }
            const navContainer = document.querySelector('header');
            const navHeight = window.getComputedStyle(navContainer).getPropertyValue('--header-sticky-height').replace(/[^\d]/g, '');
            scrollIntoViewOffset(clickDestination, navHeight);
            manageFocus(clickDestination);
          });
        }
      }
    }
  }
  /**
   * Manage focus for accessibility:
   * To make .focus() work set tabindex to -1 if element is not naturally focusable
   * If tabindex is set to -1, suppress focus-visible outline
   * Move focus to the element without triggering scroll
  */
  function manageFocus(section) {
    if (section.tabIndex < 0) {
      section.setAttribute('tabindex', '-1');
      section.classList.add('focus-visible:outline-none');
    }
    section.focus({
      preventScroll: true
    });
  }
});